import React from "react";
import { PacmanLoader } from "react-spinners";

export const PacmanLoaderWrapped = () => (
  <div style={{ height: "4em", justifyContent: "center", display: "flex", marginRight: "3em" }}>
    <PacmanLoader />
  </div>
);
